﻿<forge-toolbar *ngIf="!showHeader" slot="header" style="outline: none; position: relative;">
    <h2 slot="start" class="forge-typography--heading4">
        {{viewTitle}}
    </h2>

    <div *ngIf="grouped" slot="end" fxLayout="row" fxLayoutAlign="center center" style="width: fit-content;">
        <forge-icon-button aria-label="Expand all" (click)="expand()">
            <forge-tooltip placement="bottom">Expand all</forge-tooltip>
            <forge-icon name="expand"></forge-icon>
        </forge-icon-button>

        <forge-icon-button (click)="collapse()" aria-label="Collapse All">
            <forge-tooltip placement="bottom">Collapse All</forge-tooltip>
            <forge-icon name="arrow_collapse_vertical"></forge-icon>
        </forge-icon-button>
    </div>
</forge-toolbar>

<forge-list *ngIf="grouped">
    <card-list-group [view]="view" [groups]="groups" [datacontroller]="datacontroller" [hasBody]="hasBody"></card-list-group>
</forge-list>

<div *ngIf="!grouped" class="non-grouped">
    <div *ngFor="let model of entities" class="non-grouped-card">
        <forge-expansion-panel>
            <card-list-item-header slot="header" [cardMetadata]="view.Card" [model]="model" [datacontroller]="datacontroller" [hasBody]="hasBody"></card-list-item-header>
            <card-list-item-body *ngIf="hasBody" [cardMetadata]="view.Card" [dense]="view.Dense" [model]="model"></card-list-item-body>
        </forge-expansion-panel>
    </div>
</div>
